function SelectionFilters() {
    return {
        startDate: null,
        endDate: null,
        questions: [],
        regionId: null,
        subSurveyId: null
      }
}
export default SelectionFilters;